var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.feature === 'survey-list')?_c('survey-list',{attrs:{"userId":_vm.$store.getters.user.id,"clientId":_vm.$store.getters.clientId}}):_vm._e(),(_vm.feature === 'rewards-and-recognition')?_c('rewards-and-recognition',{attrs:{"clientId":_vm.$store.getters.user.client_id,"userId":_vm.$store.getters.user.id,"title":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }